<template>
  <div class="Index">
    <div class="l-container">
      <div class="wrapper">

        <!-- lottie -->
        <!-- <div id="app"> -->
        <!--   <lottie :options="defaultOptions" :height="400" :width="400" v&#45;on:animCreated="handleAnimation"/> -->
        <!--   <div> -->
        <!--     <p>Speed: x{{animationSpeed}}</p> -->
        <!--     <input type="range" value="1" min="0" max="3" step="0.5" -->
        <!--            v&#45;on:change="onSpeedChange" v&#45;model="animationSpeed"> -->
        <!--   </div> -->
        <!--   <button v&#45;on:click="stop">stop</button> -->
        <!--   <button v&#45;on:click="pause">pause</button> -->
        <!--   <button v&#45;on:click="play">play</button> -->
        <!-- </div> -->

        <div>
          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
            <a href="http://153.126.169.95/users/sign_up"><i class="fa fa-fw fa-plus" title="User登録"></i>
              <span>ユーザー登録</span>
              <p class="desc">ユーザー登録を行います。<br>MGR以上の権限で登録可能</p>
            </a>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
            <router-link to="/users"><i class="fa fa-fw fa-file-text" title="ユーザーリスト"></i>
              <span>ユーザーリスト</span>
              <p class="desc">NEOの登録ユーザー一覧です。<br>MGR以上の権限で閲覧可能</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
            <router-link to="/advisors"><i class="fa fa-fw fa-group" title="アドバイザー"></i>
              <span>アドバイザー</span>
              <p class="desc">アドバイザーの一覧です。</p>
            </router-link>
          </template>
        </div>


        <div>
          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link to="/appointments/add"><i class="fa fa-fw fa-plus" title="AP登録"></i>
              <span>AP登録</span>
              <p class="desc">アポ登録画面です。家庭情報とは別です。<br>契約にならなければ家庭登録はしません。</p>
            </router-link>

            <router-link to="/families/add"><i class="fa fa-fw fa-plus" title="家庭登録"></i>
              <span>家庭登録</span>
              <p class="desc">AP情報と紐付けて家庭情報を登録します。<br>個別のAP詳細画面からでも登録できます。</p>
            </router-link>

            <router-link to="/students/add"><i class="fa fa-fw fa-plus" title="生徒登録"></i>
              <span>生徒登録</span>
              <p class="desc">家庭情報と紐付けて生徒情報を登録します。<br>個別の家庭詳細画面からでも登録できます。</p>
            </router-link>

            <router-link to="/tutors/add"><i class="fa fa-fw fa-plus" title="先生登録"></i>
              <span>先生登録</span>
              <p class="desc">先生の登録画面です。</p>
            </router-link>

            <router-link to="/agreements/add"><i class="fa fa-fw fa-plus" title="契約情報登録"></i>
              <span>契約情報登録</span>
              <p class="desc">契約情報の登録画面です。<br>契約情報は家庭ではなく生徒ごとに登録します。</p>
            </router-link>
          </template>
        </div>

        <div>
          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link to="/appointments"><i class="fa fa-fw fa-file-text" title="APリスト"></i>
              <span>APリスト</span>
              <p class="desc">アポの一覧です。<br>契約前の家庭はここで管理します。</p>
            </router-link>

            <router-link to="/appointments/confirms"><i class="fa fa-fw fa-file-text" title="確認リスト"></i>
              <span>確認リスト</span>
              <p class="desc">前日確認用リストです。<br></p>
            </router-link>

            <router-link to="/families"><i class="fa fa-fw fa-file-text" title="家庭リスト"></i>
              <span>家庭リスト</span>
              <p class="desc">家庭の一覧です。<br>契約前の家庭はここにはありません。</p>
            </router-link>

            <router-link to="/students"><i class="fa fa-fw fa-file-text" title="生徒リスト"></i>
              <span>生徒リスト</span>
              <p class="desc">生徒の一覧です。<br>対応履歴は家庭と生徒で共有されます。</p>
            </router-link>

            <router-link to="/tutors"><i class="fa fa-fw fa-file-text" title="先生リスト"></i>
              <span>先生リスト</span>
              <p class="desc">先生の一覧です。<br>探しをする為のレイアウトになっています。</p>
            </router-link>

            <router-link to="/agreements"><i class="fa fa-fw fa-file-text" title="契約リスト"></i>
              <span>契約リスト</span>
              <p class="desc">契約の一覧です。<br>生徒の詳細からも閲覧、編集できます。</p>
            </router-link>
          </template>
        </div>

        <div>
          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link to="/appointmentsupports"><i class="fa fa-fw fa-file-pdf-o" title="AP対応履歴"></i>
              <span>AP対応履歴</span>
              <p class="desc">AP対応履歴の一覧です。</p>
            </router-link>

            <router-link to="/familysupports"><i class="fa fa-fw fa-file-pdf-o" title="家庭対応履歴"></i>
              <span>家庭対応履歴</span>
              <p class="desc">家庭対応履歴の一覧です。</p>
            </router-link>

            <router-link to="/tutorsupports"><i class="fa fa-fw fa-file-pdf-o" title="先生対応履歴"></i>
              <span>先生対応履歴</span>
              <p class="desc">先生対応履歴の一覧です。</p>
            </router-link>
          </template>
        </div>

        <div>
          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link to="/familyfiles"><i class="fa fa-fw fa-file-pdf-o" title="家庭ファイル"></i>
              <span>家庭ファイル</span>
              <p class="desc">契約書、口座振替依頼書、<br>などの家庭に関するPDFの一覧です。</p>
            </router-link>

            <router-link to="/studentfiles"><i class="fa fa-fw fa-file-pdf-o" title="生徒ファイル"></i>
              <span>生徒ファイル</span>
              <p class="desc">生徒に関するPDFの一覧です。<br>報告書ページができるまでここで報告書を管理します。</p>
            </router-link>

            <router-link to="/tutorfiles"><i class="fa fa-fw fa-file-pdf-o" title="先生ファイル"></i>
              <span>先生ファイル</span>
              <p class="desc">履歴書、研修資料、<br>などの先生に関するPDFの一覧です。</p>
            </router-link>

            <a href="http://153.126.169.95/student_tutors/search?limit=30" target="_blank"><i class="fa fa-fw fa-file-pdf-o" title="報告書管理"></i>
              <span>報告書管理</span>
              <p class="desc">別タブで開きます</p>
            </a>
          </template>

          <template v-if="user.type === 'admin'">
            <!-- <router&#45;link to="/reports"><i class="fa fa&#45;fw fa&#45;file&#45;pdf&#45;o" title="報告書"></i> -->
            <router-link to="/reports"><i class="fa fa-fw fa-exclamation-triangle" title="報告書"></i>
              <span>報告書</span>
              <p class="desc">メンテナンス中</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <a href="http://153.126.169.95/student_tutors/?limit=30" target="_blank"><i class="fa fa-fw fa-file-pdf-o" title="指導情報"></i>
              <span>指導情報</span>
              <p class="desc">生徒先生の紐付けです</p>
            </a>
          </template>
        </div>

        <div>
          <template v-if="user.office === '仙台'">
            <a href="/kenshus"><i class="fa fa-fw fa-leanpub" title="スケジュール"></i>
              <span>スケジュール</span>
              <p class="desc">面接、研修の予定を管理します。</p>
            </a>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link to="/student_tutors"><i class="fa fa-fw fa-file-text" title="探しデータ"></i>
              <span>探しデータ</span>
              <p class="desc">探しの管理画面です。</p>
            </router-link>

            <router-link to="/tags"><i class="fa fa-fw fa-tags" title="タグリスト"></i>
              <span>タグリスト</span>
              <p class="desc">対応履歴に紐づけるタグの管理画面です。<br>タグを削除すると対応履歴のタグも削除されます。</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin'">
            <router-link to="/events"><i class="fa fa-fw fa-file-text" title="イベントリスト"></i>
              <span>イベントリスト</span>
              <p class="desc">Todoに紐づけるイベントの管理画面です。</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin'">
            <router-link to="/todos"><i class="fa fa-fw fa-check-square" title="Todoリスト"></i>
              <span>Todoリスト</span>
              <p class="desc">個人Todo、探しTodo、<br>すべてのTodoが表示されます。</p>
            </router-link>
          </template>
        </div>

        <div>
          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
            <a href="/contracts"><i class="fa fa-fw fa-money" title="経理"></i>
              <span>経理</span>
              <p class="desc">経理管理画面です。<br>ADMIN / OWNER / ACT</p>
            </a>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'mgr'">
            <router-link to="/aggregates/appointments"><i class="fa fa-fw fa-line-chart" title="集計-AP"></i>
              <span>集計-AP</span>
              <p class="desc">アポの集計画面です。<br>ADMIN / OWNER / ACT / MGR</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner'">
            <router-link to="/aggregates/contracts"><i class="fa fa-fw fa-line-chart" title="集計-売上"></i>
              <span>集計-売上</span>
              <p class="desc">売上の集計画面です。<br>ADMIN / OWNER</p>
            </router-link>

            <router-link to="/aggregates/paymentdetails"><i class="fa fa-fw fa-line-chart" title="集計-自社割賦"></i>
              <span>集計-自社割賦</span>
              <p class="desc">自社割賦の集計画面です。<br>ADMIN / OWNER</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link to="/aggregates/tutor_channels"><i class="fa fa-fw fa-line-chart" title="集計-家庭教師"></i>
              <span>集計-家庭教師</span>
              <p class="desc">家庭教師の集計画面です。</p>
            </router-link>
          </template>
        </div>

        <div>
          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
            <router-link to="/contracts"><i class="fa fa-fw fa-exclamation-triangle" title="appointment_channels"></i>
              <span>契約情報</span>
              <p class="desc">ADMIN / OWNER / ACT</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
            <router-link to="/paymentdetails"><i class="fa fa-fw fa-exclamation-triangle" title="appointment_channels"></i>
              <span>テキスト支払</span>
              <p class="desc">ADMIN / OWNER / ACT</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
            <router-link to="/paymentdetails2s"><i class="fa fa-fw fa-exclamation-triangle" title="appointment_channels"></i>
              <span>管理費支払</span>
              <p class="desc">ADMIN / OWNER / ACT</p>
            </router-link>
          </template>
        </div>

        <div>
          <template v-if="user.type === 'admin'">
            <router-link to="/channels"><i class="fa fa-fw fa-graduation-cap" title="channels"></i>
              <span>家庭教師登録媒体</span>
              <p class="desc">ADMIN<br>媒体を管理する画面です。</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link to="/tutor_channels"><i class="fa fa-fw fa-graduation-cap" title="tutor_channels"></i>
              <span>家庭教師登録媒体リスト</span>
              <p class="desc">家庭教師が登録された媒体の一覧です。<br>重複も含めて一覧にしています。</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin'">
            <router-link to="/appointment_channels"><i class="fa fa-fw fa-exclamation-triangle" title="appointment_channels"></i>
              <span>appointment_channels</span>
              <p class="desc">メンテナンス中</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link to="/students/inheritance"><i class="fa fa-fw fa-graduation-cap" title="引継リスト"></i>
              <span>引継リスト</span>
              <p class="desc">引継リストです。</p>
            </router-link>
          </template>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// lottie
import * as animationData from '../../../assets/techno_penguin.json'
export default {
  props: {
    dtp: Object
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  data () {
    return {
      defaultOptions: {animationData: animationData},
      animationSpeed: 1
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim
    },

    stop: function () {
      this.anim.stop()
    },

    play: function () {
      this.anim.play()
    },

    pause: function () {
      this.anim.pause()
    },

    onSpeedChange: function () {
      this.anim.setSpeed(this.animationSpeed)
    }
  },
  route: {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
.Index {
  .multiselect__tags {
    padding: 0 40px 0 0;
    min-height: initial;
  }
}
</style>
<style lang="scss" scoped>
.wrapper {
  div {
    margin-top: 15px;
    display: flex;
    flex-flow: row wrap;
    a {
      font-size: 17px;
      color: #637d88;
      margin: 5px;
      width: 100%;
      max-width: 300px;
      height:100px;
      box-shadow: 0 2px 2px rgba(0,0,0,.24), 0 0 2px rgba(0,0,0,.12);
      text-decoration: none;
      text-align: center;
      padding: 25px 10px 0;
      transition: all .3s;
      &:hover {
        box-shadow: 0 4px 4px rgba(1,67,163,.24), 0 0 4px rgba(1,67,163,.12), 0 6px 18px rgba(43,133,231,.12);
        cursor: pointer;
        transform: translate3d(0,-2px,0);
        /* background: #263238; */
        /* color: #fff; */
      }
      i {
        color: #039be5;
        margin-right: 10px;
        margin-left: -20px;
        font-size: 17px;
      }
      .desc {
        font-size: 11px;
        line-height: 1.5;
      }
    }
  }
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// Index3.vue?81a93b64